(function ($) {
  Drupal.behaviors.trendReportTimelineV1 = {
    attach: function (context) {
      var $modules = $('.js-trend-report-timeline-v1', context);

      $modules.each(function () {
        var $self = $(this);
        var $play = $self.find('.js-play-button-icon');
        var $launcher = $self.find('.js-video-launcher');

        if ($play.length > 0) {
          $play
            .addClass('js-video-launch-trigger')
            .off('click.play')
            .on('click.play', function () {
              event.preventDefault();
              $launcher.trigger('click');
            });
        }
      });
    }
  };
})(jQuery);
